import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5df6f8d8")

_pushScopeId("data-v-5df6f8d8")
const _hoisted_1 = { class: "flex flex-col justify-between" }
const _hoisted_2 = { class: "w-full flex-grow flex flex-col justify-center" }
const _hoisted_3 = { class: " text-left flex flex-wrap flex-col py-8 mx-5 mb-6" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Que versícule é este? ")
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "text-xs w-full text-gray-200 opacity-80" }, [
  /*#__PURE__*/_createVNode("i", null, "Clique para ver o contexto.")
], -1)
const _hoisted_6 = {
  key: 0,
  "data-testid": "question-title-before",
  class: "select-none text-lg mb-3 opacity-80 text-white w-full"
}
const _hoisted_7 = {
  key: 1,
  "data-testid": "question-title-after",
  class: "select-none text-lg mt-4 opacity-80 text-white w-full"
}
const _hoisted_8 = {
  id: "alternatives",
  class: "p-5 flex flex-wrap content-center justify-between rounded-md"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_question_label = _resolveComponent("question-label")
  const _component_blue_button = _resolveComponent("blue-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_question_label, { class: "mb-4" }, {
          default: _withId(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }),
        (_ctx.context)
          ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.question.title[0]), 1))
          : _createCommentVNode("", true),
        _createVNode("span", {
          class: "select-none text-xl font-bold w-full text-white",
          "data-testid": "question-title",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleContext(true)))
        }, _toDisplayString(_ctx.question.title[1]), 1),
        (_ctx.context)
          ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.question.title[2]), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.question.alternatives, (alternative) => {
        return (_openBlock(), _createBlock(_component_blue_button, {
          key: alternative,
          "data-testid": alternative,
          "show-result": _ctx.showResults,
          "is-correct": alternative === _ctx.question.rightAlternative,
          class: "alternative h-12 font-semibold text-sm",
          onClick: ($event: any) => (_ctx.onSelect(alternative, _ctx.question.rightAlternative))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(alternative), 1)
          ]),
          _: 2
        }, 1032, ["data-testid", "show-result", "is-correct", "onClick"]))
      }), 128))
    ])
  ]))
})